import styled from '@emotion/styled'

export const GridContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);
`

export const FixedCard = styled.div`
  flex-shrink: 0;
  width: 370px;
`

export const BannerWrapper = styled.div`
  flex-grow: 1;
`
